import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=3b364efe&scoped=true"
import script from "./project-card.ts?vue&type=script&lang=js&external"
export * from "./project-card.ts?vue&type=script&lang=js&external"
import style0 from "./project-card.vue?vue&type=style&index=0&id=3b364efe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b364efe",
  null
  
)

export default component.exports